<template>
  <div class="approval-config-detail-table">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="mb-0">Chi tiết cấu hình</h4>
      <b-button
        class="font-weight-bolder"
        @click="addConfigDetail"
        size="sm"
        variant="primary"
        v-if="!disabled"
      >
        <i class="flaticon2-add-1 add-icon"></i>Thêm mới
      </b-button>
    </div>
    
    <b-table
      :fields="fields"
      :items="details"
      hover
      bordered
    >
      <template v-slot:cell(amount1)="row">
        <b-input
          type="text"
          size="sm"
          class="input-style text-right"
          v-model="row.item.amount1"
          v-mask="currency"
          :disabled="disabled"
        ></b-input>
      </template>
      
      <template v-slot:cell(operator1)="row">
        <b-form-select
          v-model="row.item.operator1"
          size="sm"
          :disabled="disabled"
        >
          <b-form-select-option value="1"> -- </b-form-select-option>
          <b-form-select-option value="2"> &lt; </b-form-select-option>
          <b-form-select-option value="4"> &le; </b-form-select-option>
        </b-form-select>
      </template>
      
      <template v-slot:cell(amount2)="row">
        <b-input
          type="text"
          size="sm"
          class="input-style text-right"
          v-model="row.item.amount2"
          v-mask="currency"
          :disabled="disabled"
        ></b-input>
      </template>
      
      <template v-slot:cell(gt)>
        <p class="font-weight-bold">GT</p>
      </template>
      
      <template v-slot:cell(operator2)="row">
        <b-form-select
          v-model="row.item.operator2"
          size="sm"
          :disabled="disabled"
        >
          <b-form-select-option value="1"> -- </b-form-select-option>
          <b-form-select-option value="2"> &lt; </b-form-select-option>
          <b-form-select-option value="4"> &le; </b-form-select-option>
        </b-form-select>
      </template>
      
      <template v-slot:cell(step)="row">
        <b-input
          type="text"
          size="sm"
          class="input-style text-right"
          v-model="row.item.step"
          v-mask="currency"
          :disabled="disabled"
        ></b-input>
      </template>
      
      <template v-slot:cell(configDetail)="row">
        <div
          v-if="!disabled"
          class="owner-selector"
          @click="showConfigDetailModal(row.item)"
        >
          <span>Người duyệt</span>
          <br>
          <span v-if="row.item.ownerNames.length" class="owner-names">{{ row.item.ownerNames }}</span>
        </div>
        <span v-else class="text-left">{{ row.item.ownerNames }}</span>
      </template>
      
      <template v-slot:cell(actions)="row">
        <v-icon
          small
          class="text-danger"
          @click="deleteDetail(row.item)"
          v-b-tooltip
          title="Xóa"
          :disabled="disabled"
        >mdi-delete</v-icon>
      </template>
    </b-table>
  </div>
</template>

<script>
import { v4 } from 'uuid';
import { currencyMask } from '@/utils/common';

export default {
  name: 'ApprovalConfigDetailTable',
  props: {
    /**
     * List of config details
     */
    value: {
      type: Array,
      required: true
    },
    /**
     * Whether the form is disabled
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currency: currencyMask,
      fields: [
        {
          key: 'amount1',
          label: 'Giá trị 1',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'operator1',
          label: 'Toán tử 1',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'gt',
          label: 'GT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'operator2',
          label: 'Toán tử 2',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2',
          label: 'Giá trị 2',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'step',
          label: 'Thứ tự bước',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'configDetail',
          label: 'Người duyệt',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '25%',
          },
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
      ]
    };
  },
  computed: {
    /**
     * Computed property for two-way binding
     */
    details: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    /**
     * Add a new config detail
     */
    addConfigDetail() {
      const newDetail = {
        id: v4(),
        amount1: 0,
        operator1: 1,
        gt: 'GT',
        amount2: 0,
        operator2: 1,
        ownerType: 1,
        owners: [],
        ownerNames: [],
        step: 1,
      };

      const preStep = this.details.findLast(({ step }) => step);
      if (preStep) {
        newDetail.step = Number(preStep.step) + 1;
      }

      this.details.push(newDetail);
      this.$emit('add-detail', newDetail);
    },
    
    /**
     * Show the config detail modal
     */
    showConfigDetailModal(detail) {
      this.$emit('show-owner-modal', detail);
    },
    
    /**
     * Delete a config detail
     */
    deleteDetail(detail) {
      this.$emit('delete-detail', detail);
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-config-detail-table {
  .add-icon {
    font-size: 1rem;
    margin-right: 0.25rem;
  }
  
  .input-style {
    width: 100%;
  }
  
  .owner-selector {
    cursor: pointer;
    color: blue;
    text-align: center;
    
    .owner-names {
      color: gray;
    }
  }
}
</style>
